import { getToken } from "./auth/tokenAuth";
import doRequest from "./helpers";
//#region Utils
import { base64ToBlob } from "utils/conversions";
import { FAKE_DATA, USE_FAKE_DATA } from "./fakeData";
import { VIRTUAL_CAMPUS_ID } from "config/constants";
//#endregion

//#region Helpers
export const getPublicOfEntity = publicLoad => {
	if (publicLoad?.id === undefined || publicLoad?.id === 1) {
		const { students } = publicLoad;
		let res = {
			campusIds: students.publicByCampusIds,
		};
		if (students?.modalityId)
			res = {
				...res,
				idModalidad: students.modalityId,
			};
		return {
			estudiantesGeneral: { ...res },
		};
	} else if (publicLoad.id === 2) {
		const { studentsFile } = publicLoad.list;
		if (studentsFile.base64)
			return {
				estudiantesArchivo: {
					archivo: studentsFile.base64,
					nombre: studentsFile.name,
				},
			};
	}
	return {};
};
export const filterCampusVirtual = (campusList = []) => {
	return campusList.filter(({ code }) => code !== VIRTUAL_CAMPUS_ID);
};
//#endregion
//#region Requests
export const requestGetModalities = async () => {
	const [result, err] = await doRequest(
		`/Modalidad`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listModalidad.map(({ idModalidad, nombre }) => {
		return {
			id: idModalidad,
			name: nombre,
		};
	});
};
export const requestGetLocations = async () => {
	const [result, err] = await doRequest(
		`/Ubicacion`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listUbicacion.map(({ idUbicacion, nombre, icono }) => {
		return {
			id: idUbicacion,
			name: nombre,
			icon: base64ToBlob(icono, "image/svg+xml"),
		};
	});
};
export const requestGetInscriptionEventTypes = async () => {
	const [result, err] = await doRequest(
		"/EventoInscripcion",
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listEventoInscripcion.map(
		({ linkInscripcionId, nombre }) => {
			return {
				id: linkInscripcionId,
				name: nombre,
			};
		}
	);
};
export const requestGetAllDays = async () => {
	const [result, err] = await doRequest("/Dia", "GET", null, getToken());
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.dia.map(({ idDia, nombre }) => {
		return {
			id: idDia,
			name: nombre,
		};
	});
};
export const requestGetAllCampus = async () => {
	if (USE_FAKE_DATA) return [...FAKE_DATA.ALL_CAMPUS];
	const [result, err] = await doRequest("/Campus", "GET", null, getToken());
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listCampus.map(
		({ idCampus: id, codigo: code, nombre: name, direccion: address }) => {
			return { id, name, code, address };
		}
	);
};
export const requestGetAllCampusDetail = async () => {
	const [result, err] = await doRequest(
		"/CampusDetalle",
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.campusDetalle.map(
		({ campusDetalleId: id, idCampus: campusId, nombre: name, direccion: address }) => {
			return {
				id,
				campusId,
				name,
				address,
			};
		}
	);
};
export const requestGetCampusEnvironments = async () => {
	const [result, err] = await doRequest("/Ambiente", "GET", null, getToken());
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listaAmbiente.map(
		({ idConsultorio, idCampus, espacio, direccion }) => {
			return {
				id: idConsultorio,
				campusId: idCampus,
				name: espacio,
				address: direccion,
			};
		}
	);
};
export const requestGetTeacherAccounts = async () => {
	const [result, err] = await doRequest(
		"/CuentaDocente/",
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listCuentaDocente.map(
		({ cuentaDocenteId, cuentaMail }) => {
			return {
				id: cuentaDocenteId,
				email: cuentaMail,
			};
		}
	);
};
export const requestGetTeachers = async (
	teacherName,
	module,
	similar = false
) => {
	const similarPath = similar ? "Similar" : "";
	const [result, err] = await doRequest(
		`/Docente${similarPath}/Buscar`,
		"POST",
		{
			nombreDocente: teacherName.trim(),
			modulo: module,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listDocenteName;
};
export const requestGetTeacherById = async teacherId => {
	const [result, err] = await doRequest(
		`/LeerCodigoDocente/${teacherId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listDocenteName[0].nombreDocente;
};
export const requestGetCoursesByCatalogCode = async courseCatalogCode => {
	const [result, err] = await doRequest(
		`/CodCatalogoCurso`,
		"POST",
		{
			codCatalogCurso: courseCatalogCode,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listCodCatalogCurso.map(
		({
			codigoCurso: id,
			idCatalogo: catalogCode,
			nombreCurso,
			modalidadCurso,
		}) => {
			return {
				id,
				catalogCode,
				text: `${nombreCurso} - ${modalidadCurso}`,
			};
		}
	);
};
export const requestGetCourseNameById = async courseId => {
	const [result, err] = await doRequest(
		`/LeerNombrePorCodigoCurso/${courseId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.NombreCurso;
};
export const requestGetServerTime = async () => {
	const [result, err] = await doRequest(
		"/RefuerzoAcademico/TraerHoraActual",
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.hora;
};
export const requestGetNameStudentById = async studentId => {
	const [result, err] = await doRequest(
		`/LeerCodigoAlumno`,
		"POST",
		{
			idAlumno: studentId.trim(),
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.alumnoNombres;
};
export const requestSearchStudentsByStudentId = async studentId => {
	const [result, err] = await doRequest(
		`/ReservaRecurso/BuscarAlumnos`,
		"POST",
		{
			codAlumno: studentId,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data?.alumnos.map(({ idAlumno, nombres }) => ({
		id: idAlumno,
		name: nombres,
	}));
};
export const requestGetPayGrades = async () => {
	const [result, err] = await doRequest(
		"/RefuerzoAcademico/CategoriaSalarial",
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listCategoriaSalarial.map(({ codigo: id }) => ({ id }));
};
//#endregion
